module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }